import React from "react";
import ReactDOM from "react-dom/client";

import { App } from "@/App";
import { initDensity } from "@/lib/density";
import "@/lib/i18n";
import { initTheme } from "@/lib/theme";
import "@/styles/globals.css";

// Tema applicato prima del render per evitare il flash white→dark
// (FOUC) quando l'utente ha "dark" in localStorage o nel sistema.
initTheme();
initDensity();

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("root element missing in index.html");
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
